// 获取token
export function getToken() {
  return localStorage.getItem('token')
}

// 设置token
export function setToken(token) {
  localStorage.setItem('token', token)
}

// 移除token
export function removeToken() {
  localStorage.removeItem('token')
}

// 检查是否已登录
export function isLoggedIn() {
  return !!getToken()
}

// 获取用户名
export function getUsername() {
  return localStorage.getItem('username') || '管理员'
}

// 设置用户名
export function setUsername(username) {
  localStorage.setItem('username', username)
}

// 清除所有认证信息
export function clearAuth() {
  localStorage.removeItem('token')
  localStorage.removeItem('username')
}

// 检查token是否过期（简单实现，实际项目中可能需要解析JWT）
export function isTokenExpired() {
  const token = getToken()
  if (!token) return true
  
  // 这里可以添加token过期检查逻辑
  // 例如：解析JWT的exp字段，检查是否过期
  return false
}
